import { render, staticRenderFns } from "./SolicitacaoManutencaoList.vue?vue&type=template&id=514d01a5"
import script from "./SolicitacaoManutencaoList.vue?vue&type=script&lang=js"
export * from "./SolicitacaoManutencaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports